import React, { useEffect, useState } from 'react';
import './catalog-list.scss';
import { getFormattedAmount } from '@zonofi/common';
import {
  SVGS,
  SegmentTag,
  SegmentTagsPopup,
} from '@zonofi/zono-money-design-system';
import {
  CatalogListData,
  CatalogueView,
  LineInOrder,
  getCustomerInvite,
  PricingStrategy,
  ProductSegmentMetric,
} from '@zonofi/zono-money-store';
import { OutOfStockErrorSnackBar } from '../out-of-stock-error-snackbar/out-of-stock-error-snackbar';
import { CategoryTag } from './category-tag';
import { useCatalogList } from './useCatalogList';
import { useAppSelector } from '@zonofi/zono-money-helpers';
import { MoqErrorSnackBar } from '../moq-error-snackbar/moq-error-snackbar';
import { RenderAddButton } from '../catalog-list-add-to-cart-button/catalog-list-add-to-cart-button';
import { WeightedPriceInfo } from '../weighted-price-info/weighted-price-info';

interface CatalogListProps {
  products: CatalogListData[];
  onDecrement: (
    item: LineInOrder,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  onIncrement: (
    item: LineInOrder,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  onAddToCart: (item: CatalogListData) => any;
  onDelete: (
    item: LineInOrder,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  onChangeQuantity: (
    item: LineInOrder,
    newQty: number,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  showImage: boolean;
  showPrice: boolean;
  listView: boolean;
  catalogueView: CatalogueView;
  showOutOfStack: boolean;
  showActionButtons?: boolean;
}

export const CatalogList: React.FC<CatalogListProps> = ({
  products,
  onAddToCart,
  onIncrement,
  onDecrement,
  onDelete,
  onChangeQuantity,
  showImage,
  showPrice,
  listView,
  catalogueView,
  showOutOfStack,
  showActionButtons = true,
}) => {
  const [visibleTagsCount, setVisibleTagsCount] = useState(2);
  const [showOutofStockError, setShowOutofStockError] = useState(false);

  const inviteDetails = useAppSelector(getCustomerInvite);
  const { seller, inviteId } = inviteDetails;
  const { quantityMap, setQuantityMap, openProductDetails } = useCatalogList(
    products,
    catalogueView,
    showPrice
  );

  const updateVisibleTags = () => {
    if (window.innerWidth < 1279) {
      setVisibleTagsCount(1);
    } else if (window.innerWidth >= 1280 && window.innerWidth <= 1479) {
      setVisibleTagsCount(2);
    } else {
      setVisibleTagsCount(3);
    }
  };

  useEffect(() => {
    updateVisibleTags();
    window.addEventListener('resize', updateVisibleTags);
    return () => window.removeEventListener('resize', updateVisibleTags);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShowOutofStockError(false);
    }, 5000);
  }, [showOutofStockError]);

  return products?.map((item, index) => {
    const disc = Number(item?.promotions?.[0]?.discount);
    const discType = item?.promotions?.[0]?.promotionType;
    const sortedCategories = [...(item?.categories ?? [])].sort(
      (a, b) => a.categoryName.length - b.categoryName.length
    );
    let showStrikeThroughPrice = false;
    let margin = 0;
    if (item?.ptr && item?.pts) {
      margin = item.ptr - item.pts;
    }
    showStrikeThroughPrice = Boolean(
      item?.pts && item?.mrp && item?.mrp > 0 && item?.mrp > item?.pts
    );

    console.log('showOutOfStack', showOutOfStack);

    // const segments =
    //   item?.segments?.filter(
    //     (x) =>
    //       x?.segmentName === ProductSegmentMetric.FAST_MOVING ||
    //       x?.segmentName === ProductSegmentMetric.NEW_LAUNCH
    //   ) || [];

    // const visibleSegments = segments.slice(0, visibleTagsCount);

    // const moreSegments = segments.slice(visibleTagsCount);

    // !isNaN(disc) &&
    // discType !== 'buy_x_get_y_free' &&
    // item?.isAddedToCart &&
    // item?.addedQty >= item?.minOrderQty;
    let updatedImageURL = item?.productImage;
    if (updatedImageURL && updatedImageURL.startsWith('http')) {
      const urlObj = new URL(item?.productImage ?? '');
      if (urlObj) {
        if (!listView) {
          urlObj.searchParams.set('width', '100');
          urlObj.searchParams.delete('height');
        } else {
          urlObj.searchParams.set('width', '300');
          urlObj.searchParams.delete('height');
        }
        updatedImageURL = urlObj.toString();
      }
    }

    const parentInfo = {
      isParent: item?.pvIds?.length > 1,
      isAddedToCart: item?.accQty > 0,
      accQty: item?.accQty,
      onClick: () =>
        openProductDetails(item?.productId, item?.productVariantId),
    };
    const formatTitle = (input: string) => {
      if (/[A-Z]/.test(input)) return input;
      // Otherwise, convert each space-separated word to Title Case.
      return input
        .split(' ')
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');
    };

    // const imageList = [PNGS.RosePinkImage, PNGS.CamelImage];
    // const imageList = [PNGS.CamelImage, PNGS.RosePinkImage, PNGS.SaheliGhera1, PNGS.SaheliGhera2, PNGS.TruptiFeedinggheraGrey, PNGS.TruptiFeedinggheraPurple, PNGS.TruptiFeedinggheraRed];
    // const selectedImage = imageList[index % imageList.length];

    return (
      <>
        <div
          className={`catalog-list-item${listView ? '-grid-' : '-'}container`}
          key={index}
        >
          <div className={`catalog-list-item${listView ? '-grid' : ''}`}>
            {showImage && (
              <div
                className={`catalog-list-item${
                  listView ? '-grid-' : '-'
                }img-container`}
                onClick={() =>
                  openProductDetails(item?.productId, item?.productVariantId)
                }
              >
                <img
                  src={updatedImageURL ? updatedImageURL : SVGS.DefaultProduct}
                  alt=""
                  className={`catalog-list-item${listView ? '-grid-' : '-'}img`}
                  onError={(e) => {
                    e.currentTarget.src = SVGS.DefaultProduct;
                  }}
                />
                {/* <img
                  src={selectedImage}
                  alt=""
                  className={`catalog-list-item${listView ? '-grid-' : '-'}img`}
                /> */}
              </div>
            )}
            <div
              className={`catalog-list-item${
                listView ? '-grid-' : '-'
              }info-container`}
            >
              <div
                className={`catalog-list-item${listView ? '-grid-' : '-'}info`}
                onClick={() =>
                  openProductDetails(item?.productId, item?.productVariantId)
                }
              >
                <span
                  className={`catalog-list-item${
                    listView ? '-grid-' : '-'
                  }info-name font-primary`}
                >
                  {formatTitle(item?.name ?? '')}
                </span>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 8,
                  }}
                >
                  {/* {visibleSegments?.length > 0 && (
                    <div className="catalog-list-item-info-tags">
                      {visibleSegments.map((item, index) =>
                        item ? (
                          <SegmentTag key={index} mainText={item.segmentName} />
                        ) : null
                      )}
                      {moreSegments.length > 0 && (
                        <SegmentTagsPopup tags={moreSegments} />
                      )}
                    </div>
                  )} */}
                  {showOutOfStack && item?.stock < 1 && (
                    <div className="catalog-list-out-of-stack-tag">
                      <span className="catalog-list-out-of-stack-tag-text font-primary">
                        OUT OF STOCK
                      </span>
                    </div>
                  )}

                  {sortedCategories && sortedCategories?.length !== 0 && (
                    <div className="catalog-list-item-info-tags">
                      {sortedCategories?.length !== 0 &&
                        sortedCategories
                          ?.slice(0, 2)
                          ?.map((category, jindex) => {
                            return (
                              <CategoryTag category={category} key={jindex} />
                            );
                          })}
                      {sortedCategories.slice(2)?.length > 0 && (
                        <CategoryTag
                          category={{
                            categoryCode: '',
                            categoryId: 0,
                            categoryName:
                              '+' + sortedCategories?.slice(2)?.length,
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
                {item?.pvIds?.length === 1 && item?.facets?.length !== 0 && (
                  <div className="catalog-list-item-facets">
                    {item?.facets?.map((f) => {
                      return (
                        <span className="catalog-list-item-facets-facet">
                          {f?.name}: {f?.values?.[0]?.facetValue}
                        </span>
                      );
                    })}
                  </div>
                )}
                {showPrice && (
                  <span className="catalog-list-item-info-price-container font-primary-semibold">
                    {showStrikeThroughPrice ? (
                      <div className="catalog-list-item-info-price-container">
                        <span className="catalog-list-item-info-price-container font-primary-semibold">
                          {getFormattedAmount(item?.pts ?? 0) ?? 0}
                        </span>
                        <span className="catalog-list-item-info-price-container-striked font-primary">
                          {getFormattedAmount(item?.mrp ?? 0) ?? 0}
                        </span>
                        {item?.pricingStrategy ===
                          PricingStrategy.WEIGHT_BASED && (
                          <WeightedPriceInfo
                            weightedPrice={item?.weightedPrice}
                          />
                        )}
                      </div>
                    ) : (
                      <>
                        <span className="catalog-list-item-info-price-container font-primary-semibold">
                          {getFormattedAmount(item?.pts ?? 0) ?? 0}
                        </span>
                        {item?.pricingStrategy ===
                          PricingStrategy.WEIGHT_BASED && (
                          <WeightedPriceInfo
                            weightedPrice={item?.weightedPrice}
                          />
                        )}
                      </>
                    )}
                    {/* {isNumber(item?.ptr) && item?.ptr > 1 && margin > 0 && (
                      <>
                        <span> • </span>
                        <span className="catalog-list-item-info-price-container-margin font-primary">
                          {`Margin: ${getFormattedAmount(margin)}`}
                        </span>
                      </>
                    )} */}
                  </span>
                )}

                {item?.promotions && item?.promotions?.length !== 0 && (
                  <div className="catalog-list-item-promotion">
                    <img src={SVGS.DiscountIcon} alt="discount" />
                    <span className="catalog-list-item-promotion-text font-primary-semibold">
                      {item?.promotions?.[0]?.name}
                      {/* {item?.promotions?.[0]?.promotionType ===
                      SchemeTypes.BUYXGETY
                        ? `Buy ${item?.promotions?.[0]?.minQtyASC} Qty, get ${item?.promotions?.[0]?.freeQtyASC} free`
                        : `Buy ${item?.promotions?.[0]?.minQtyASC} Qty, get ${item?.promotions?.[0]?.discount} % off`} */}
                    </span>
                  </div>
                )}
              </div>

              {!listView && showActionButtons && (
                <div className="catalog-list-item-button-container">
                  <RenderAddButton
                    item={item}
                    seller={seller}
                    inviteId={inviteId}
                    onDelete={onDelete}
                    onIncrement={onIncrement}
                    onDecrement={onDecrement}
                    onChangeQuantity={onChangeQuantity}
                    setQuantityMap={setQuantityMap}
                    quantityMap={quantityMap}
                    onAddToCart={onAddToCart}
                    listView={listView}
                    parentInfo={parentInfo}
                    showOutOfStack={showOutOfStack}
                    setShowOutofStockError={setShowOutofStockError}
                  />
                </div>
              )}
            </div>
            {listView && showActionButtons && (
              <div className="catalog-list-item-grid-button-container">
                <RenderAddButton
                  item={item}
                  seller={seller}
                  inviteId={inviteId}
                  onDelete={onDelete}
                  onIncrement={onIncrement}
                  onDecrement={onDecrement}
                  onChangeQuantity={onChangeQuantity}
                  setQuantityMap={setQuantityMap}
                  quantityMap={quantityMap}
                  onAddToCart={onAddToCart}
                  listView={listView}
                  parentInfo={parentInfo}
                  showOutOfStack={showOutOfStack}
                  setShowOutofStockError={setShowOutofStockError}
                />
              </div>
            )}
          </div>
          {/* {item?.moqError && (
              <span className="catalog-list-item-container-moq-error font-primary">
                Qty cannot be less than MOQ
              </span>
            )} */}
        </div>
        {item?.moqError && !showOutofStockError && (
          <div className="catalog-list-moq-error-container">
            <MoqErrorSnackBar number={item.minOrderQty} />
          </div>
        )}
        {showOutofStockError && !item?.moqError && (
          <div className="catalog-list-moq-error-container">
            <OutOfStockErrorSnackBar number={item.stock} />
          </div>
        )}
      </>
    );
  });
};
